import { Grid } from "@mui/material";
import AdVidsInMachine from "pages/advertisement/ad_videos/in_machine/AdVidsInMachine";
import AdVidsInMachineItem from "pages/advertisement/ad_videos/in_machine/AdVidsInMachineItem";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  adsVideoAllocationSelector,
  getVideoAllocationsThunk,
} from "store/reducers/advertisement/adsVideoAllocationSlice";

const AdVidsInMachineList = ({ m_id }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getVideoAllocationsThunk(m_id));
  }, []);
  const drawerOpen = useSelector((state) => state.menu.drawerOpen);
  const adVids = useSelector(adsVideoAllocationSelector.selectAll).filter(
    (item) => item.machine === m_id
  );
  return (
    <>
      <Grid container spacing={1} marginTop={1}>
        {adVids.map((video) => (
          <Grid
            item
            xl={3}
            lg={drawerOpen ? 4 : 3}
            md={6}
            xs={12}
            key={video.id}
          >
            <AdVidsInMachineItem item={video} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default AdVidsInMachineList;
